import React from 'react';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BarChartWeekly = ({ weekData }) => {
    const currentYear = moment().format('YYYY');
    const lastYear = moment().subtract(1, 'years').format('YYYY');

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    boxWidth: 12,
                    padding: 15,
                },
            },
            title: {
                display: false,
            },
            datalabels: {
                display: false,
            },
        }
        ,
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 5,
                },
                grid: {
                    drawBorder: false,
                    color: '#eee',
                },
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <div className='cdashboard_box_bar'>
            <div className='cdashboard_box_bar_top'>
                <div className='cdashboard_box_bar_top_left'>
                    <h3>Scanning Status ({lastYear}-{currentYear})</h3>
                </div>
                {/* <div className='cdashboard_box_bar_top_right'>
                    <select>
                        <option>Weekly</option>
                        <option>Monthly</option>
                    </select>
                </div> */}
            </div>
            <div className='cdashboard_box_bar_bottom'>
                <Bar data={weekData} options={options} />
            </div>
        </div>
    );
};

export default BarChartWeekly;